module.exports = __webpack_public_path__ + "static/media/icon-attachment.e8196f48.png";